export enum ModeOfExportEnum{
    CONTAINER = 'CONTAINER',
    FLIGHT = 'FLIGHT'

}